import { useEffect, useState } from 'react';
import Toast from 'react-bootstrap/Toast';
import ToastContainer, { ToastContainerProps, ToastPosition } from 'react-bootstrap/ToastContainer';
import { createPortal } from 'react-dom';
import { CustomToast } from '../models/toast';

const ToastComponent = (props: ToastComponentProps) => {
  const { toastList, position, autoDelete, autoDeleteTime } = props;
  const [list, setList] = useState(toastList);
  useEffect(() => {
    setList([...toastList]);
  }, [toastList]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (autoDelete && toastList.length && list.length) {
        deleteToast(toastList[0].id);
      }
    }, autoDeleteTime);
    return () => {
      clearInterval(interval);
    };
    // eslint-disable-next-line
  }, [toastList, autoDelete, autoDeleteTime, list]);
  const deleteToast = (id: number) => {
    const listItemIndex = list.findIndex((e: CustomToast) => e.id === id);
    const toastListItem = toastList.findIndex((e: CustomToast) => e.id === id);
    list.splice(listItemIndex, 1);
    toastList.splice(toastListItem, 1);
    setList([...list]);
  };
  return createPortal(
    <>
      <ToastContainer position={position} className="p-3">
        {list.map((toast: CustomToast, i) => (
          <Toast key={i} bg={toast.backgroundColor.toLocaleLowerCase()} animation={true}>
            <Toast.Header closeButton={false}>
              <strong className="me-auto fs-5">{toast.title}</strong>
              <button type="button" className="btn-close" onClick={() => deleteToast(toast.id)}></button>
            </Toast.Header>
            <Toast.Body
              className={
                (toast.backgroundColor === 'Dark' && 'text-white') ||
                (toast.backgroundColor === 'Light' && 'text-dark') ||
                'text-white'
              }
            >
              <img src={toast.icon} className="rounded me-2" alt="" />
              <span className="fs-5">{toast.description}</span>
            </Toast.Body>
          </Toast>
        ))}
      </ToastContainer>
    </>,
    document.body
  );
};

export interface ToastComponentProps extends ToastContainerProps {
  toastList: Array<CustomToast>;
  position: ToastPosition;
  autoDelete: boolean;
  autoDeleteTime: number;
}
export default ToastComponent;
